// App.js - Root-Komponente mit Routing
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Komponenten
import Login from './components/Login';
import TimeTrackingApp from './components/TimeTrackingApp';
import AdminPanel from './components/AdminPanel';
import SuperUserLogin from './components/SuperUserLogin';
import SuperUserDashboard from './components/SuperUserDashboard';

// Benutzer-App (/)
const UserApp = () => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const handleLogin = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <div className="App">
      {user ? (
        <TimeTrackingApp user={user} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
};

// Admin-App (/admin)
const AdminApp = () => {
  const [user, setUser] = useState(() => {
    const savedAdmin = localStorage.getItem('admin');
    const parsed = savedAdmin ? JSON.parse(savedAdmin) : null;
    // Gespeicherte Anmeldung nur mit Admin-Rolle übernehmen  // #P361#
    if (parsed?.role === 'admin') return parsed;
    localStorage.removeItem('admin');
    return null;
  });

  const handleLogin = (userData) => {
    localStorage.setItem('admin', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin');
    setUser(null);
  };

  return (
    <div className="App">
      {user ? (
        <AdminPanel user={user} onBack={handleLogout} />
      ) : (
        <Login
          onLogin={handleLogin}
          scope="admin"
          title="Administrator Login"
          subtitle="Verwaltung Ihrer Mandanten-Daten"
        />
      )}
    </div>
  );
};

// Super-Admin-App (/superuser)
const SuperUserApp = () => {
  const [user, setUser] = useState(() => {
    const savedSuperUser = localStorage.getItem('superuser');
    const parsed = savedSuperUser ? JSON.parse(savedSuperUser) : null;
    // Gespeicherte Anmeldung nur mit Token übernehmen  // #P362#
    if (parsed?.token) return parsed;
    localStorage.removeItem('superuser');
    return null;
  });

  const handleLogin = (userData) => {
    localStorage.setItem('superuser', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('superuser');
    setUser(null);
  };

  return (
    <div className="App">
      {user ? (
        <SuperUserDashboard user={user} onLogout={handleLogout} />
      ) : (
        <SuperUserLogin onLogin={handleLogin} />
      )}
    </div>
  );
};

// Haupt-App mit Routing
const App = () => {
  return (
    <Router>
      <Routes>
        {/* Benutzer-App (Zeiterfassung) */}
        <Route path="/" element={<UserApp />} />

        {/* Admin-App (Mandanten-Verwaltung) */}
        <Route path="/admin" element={<AdminApp />} />

        {/* Super-Admin-App (Globale Verwaltung) */}
        <Route path="/superuser" element={<SuperUserApp />} />

        {/* Fallback - Weiterleitung zur Haupt-App */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
